import {
  UseMutationOptions,
  UseQueryOptions,
  useMutation,
  useQuery,
} from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import { ClubRegularDto, ManagerClubRegularDto } from "@/shared/api";
import { useApi } from "@/shared/api/use-api";

export const useSysDataClubsQuery = (
  {
    domain,
  }: {
    domain: string;
  },
  queryOptions?: Omit<UseQueryOptions<AxiosResponse<ClubRegularDto[]>>, "queryKey">
) => {
  const { sysDataCommonApi } = useApi();

  return useQuery({
    queryKey: [`/sys-data/${domain}/clubs`],
    queryFn: ({ signal }) => sysDataCommonApi.getClubs(domain, { signal }),
    ...queryOptions,
  });
};

export const useSysDataManagerClubsQuery = (
  {
    domain,
  }: {
    domain: string;
  },
  queryOptions?: Omit<UseQueryOptions<AxiosResponse<ManagerClubRegularDto[]>>, "queryKey">
) => {
  const { sysDataCommonApi } = useApi();

  return useQuery({
    queryKey: [`/sys-data/${domain}/manager_clubs`],
    queryFn: ({ signal }) => sysDataCommonApi.getManagerClubs(domain, { signal }),
    ...queryOptions,
  });
};

export const useSysDataWhitelistQuery = (
  {
    domain,
  }: {
    domain: string;
  },
  queryOptions?: Omit<UseQueryOptions<AxiosResponse<Set<string>>>, "queryKey">
) => {
  const { sysDataCommonApi } = useApi();

  return useQuery({
    queryKey: [`/sys-data/${domain}/whitelist`],
    queryFn: ({ signal }) => sysDataCommonApi.getRoomWhitelist(domain, { signal }),
    ...queryOptions,
  });
};

export const useSysDataUpdateWhitelistMutation = (
  {
    domain,
  }: {
    domain: string;
  },
  mutationOptions?: UseMutationOptions<
    AxiosResponse<void>, // результат
    unknown, // ошибка
    Set<string> // переменная (whitelistValues)
  >
) => {
  const { sysDataCommonApi } = useApi();

  return useMutation({
    mutationKey: [`/sys-data/${domain}/whitelist`],
    mutationFn: (whitelistValues: Set<string>) =>
      sysDataCommonApi.saveRoomWhitelist(domain, whitelistValues),

    ...mutationOptions,
  });
};
